export default {
  videoFile: {
    rePlayVideoBtn: '重新播放',
    playVideoBtn: '播放视频',
    stopVideoBtn: '暂停视频',
  },
  videoLoop: {
    loopNumber: '播放次数',
    playEndFrame: '保持尾帧',
    title: '播放',
    autoPlay: '自动播放',
    autoPlayText: '入场自动播放',
    loop: '无限循环',
  },
  videoSound: {
    videoSound: '视频声音',
    muteSound: '静音',
    title: '声音',
  },
  videoEditor: {
    argumentsAreEmpty: 'url, onCrop 是必传参数',
  },
}
